module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image6b.d1a633e9.jpg";